export default "__VITE_ASSET__Dy3mi$V8__"